"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.value2index = value2index;
exports.DropdownItem = exports.Dropdown = exports.BasicDropdown = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _DropdownButton = _interopRequireDefault(require("react-bootstrap/lib/DropdownButton"));

var _dropdownButtonTethered = _interopRequireDefault(require("./dropdown-button-tethered"));

var _FormControl = _interopRequireDefault(require("react-bootstrap/lib/FormControl"));

var _MenuItem = _interopRequireDefault(require("react-bootstrap/lib/MenuItem"));

var _ThemeProvider = require("../ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _utils = require("../../utils");

var _Nil = require("@phg/stilo-utils/Nil");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function value2index(_ref) {
  var options = _ref.options,
      value = _ref.value;
  if (options === undefined || options === null) return -1;
  if (value === undefined || value === null) return -1;
  return options.map(function (option) {
    return option.value.toString();
  }).indexOf(value.toString());
}

var preventDefault = function preventDefault(event) {
  return event.preventDefault();
};
/* Convert DropDownItem to plain option object.
   We copy all properties and rename children prop to name */


var childToOption = function childToOption(child) {
  var _child$props = child.props,
      children = _child$props.children,
      props = (0, _objectWithoutProperties2["default"])(_child$props, ["children"]);
  return _objectSpread({
    name: children
  }, props);
};

var propsToStateOptions = function propsToStateOptions(props) {
  var options;

  if (props.children != null) {
    options = props.children.map(childToOption);
  } else {
    options = props.options;
  }

  return options.map(function (option, eventKey) {
    return _objectSpread(_objectSpread({}, option), {}, {
      eventKey: eventKey
    });
  });
};

var BasicDropdown = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(BasicDropdown, _React$Component);

  var _super = _createSuper(BasicDropdown);

  function BasicDropdown(_props) {
    var _this;

    (0, _classCallCheck2["default"])(this, BasicDropdown);
    _this = _super.call(this, _props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "UNSAFE_componentWillReceiveProps", function (props) {
      var newState = {
        options: propsToStateOptions(props)
      };

      if (props.value !== undefined) {
        newState.eventKey = value2index({
          options: props.options,
          value: props.value
        });
      }

      _this.setState(newState);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (eventKey) {
      _this.setState({
        eventKey: eventKey
      });

      if (_this.state.options) {
        _this.props.returnSingleValue ? _this.props.onSelect(_this.state.options[eventKey].value) : _this.props.onSelect({
          target: {
            name: _this.props.name,
            value: _this.state.options[eventKey].value,
            type: 'select-one'
          }
        });
      } else if (_this.props.children) {
        /* FIXME
         *
         * `fromNullableOrDefault` is being used incorrectly here.
         * It should be applied like `fromNullableOrDefault('')(value)`,
         * othwerwise `value` is ignored and `name` becomes a function.
         * 
         * FTN-20 COQ-3141 Matthias Reinarz 2021-07-07
         */
        var name = (0, _Nil.fromNullableOrDefault)('', _this.props.children.filter(function (node) {
          return node.props.eventKey === eventKey;
        }).map(function (node) {
          return node.props.children;
        })[0]);
        _this.props.returnSingleValue ? _this.props.onSelect(_this.props.value) : _this.props.onSelect({
          target: {
            name: name,
            value: _this.props.value,
            type: 'select-one'
          }
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onToggle", function (state) {
      _this.props.onToggle !== undefined && _this.props.onToggle(state);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPlaceholder", function () {
      return _this.props.placeholder ? _this.props.placeholder : 'Choose...';
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getNameOrPlaceholder", function (source) {
      if (_this.state.eventKey >= 0 && source[_this.state.eventKey]) {
        return source[_this.state.eventKey].name;
      }

      return _this.getPlaceholder();
    });
    var tempState = {
      filter: ''
    };
    tempState.options = propsToStateOptions(_this.props);
    tempState.eventKey = value2index({
      options: tempState.options,
      value: _this.props.value
    });
    _this.state = tempState;
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onToggle = _this.onToggle.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getTitle = _this.getTitle.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setFilter = _this.setFilter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.filterOptions = _this.filterOptions.bind((0, _assertThisInitialized2["default"])(_this));
    _this.createTextField = _this.createTextField.bind((0, _assertThisInitialized2["default"])(_this));
    _this.removeButton = _this.removeButton.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(BasicDropdown, [{
    key: "getTitle",
    value: function getTitle() {
      if (this.props.title != null) {
        return this.props.title;
      } else if (this.state.options != null) {
        return this.getNameOrPlaceholder(this.state.options);
      } else if (this.props.children != null) {
        return this.getNameOrPlaceholder(this.state.children);
      }

      return this.getPlaceholder();
    }
  }, {
    key: "setFilter",
    value: function setFilter(filter) {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        filter: filter.target.value
      }));
    }
  }, {
    key: "filterOptions",
    value: function filterOptions(item) {
      if (this.state.filter.length > 0) {
        var regEx = new RegExp(this.state.filter, 'i');
        return item.name.match(regEx);
      }

      return true;
    }
  }, {
    key: "createTextField",
    value: function createTextField() {
      var _this2 = this;

      return [/*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: "search-field",
        header: true,
        eventKey: -2
      }, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        tabIndex: "-1",
        key: "search-input",
        ref: function ref(input) {
          _this2.filterInput = input;
        },
        type: "text",
        value: this.state.filter,
        onChange: this.setFilter.bind(this)
      })), /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: "select-all-sep",
        divider: true
      })];
    }
  }, {
    key: "removeButton",
    value: function removeButton(onClick) {
      return /*#__PURE__*/_react["default"].createElement("button", {
        className: "inputRemoveButton",
        onClick: onClick
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "minusGlyph"
      }, "-"));
    } // eslint-disable-next-line complexity

  }, {
    key: "render",
    value: function render() {
      var title = /*#__PURE__*/_react["default"].createElement("div", {
        className: "dropdown-label"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: this.props.icon
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'title'
      }, this.getTitle()));

      var flexClass = this.props.disableFlex ? 'disable-flex' : '';
      var Component = this.props.tethered ? _dropdownButtonTethered["default"] : _DropdownButton["default"];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.props.classes.Dropdown, " ").concat(flexClass),
        id: this.props.id + '-select'
      }, /*#__PURE__*/_react["default"].createElement(Component, {
        pullRight: this.props.pullRight,
        disabled: this.props.disabled,
        onSelect: this.onChange,
        onToggle: this.onToggle,
        id: this.props.id,
        title: title
      }, this.props.filter ? this.createTextField() : null, this.state.options ? this.state.options.filter(this.filterOptions).map(function (itemProps, i) {
        //spread all the props we receive out into menuitem (eg disabled, value etc)
        var name = itemProps.name,
            props = (0, _objectWithoutProperties2["default"])(itemProps, ["name"]);
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({
          key: "mi-".concat(i)
        }, props), name);
      }) : this.props.children), this.props.isRemovable ? this.removeButton(_utils.S.pipe([preventDefault, this.props.onRemove])) : null);
    }
  }]);
  return BasicDropdown;
}(_react["default"].Component);

exports.BasicDropdown = BasicDropdown;
(0, _defineProperty2["default"])(BasicDropdown, "propTypes", {
  title: _propTypes["default"].node,
  classes: _propTypes["default"].object,
  pullRight: _propTypes["default"].bool,
  onSelect: _propTypes["default"].func,
  onToggle: _propTypes["default"].func,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  name: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    name: _propTypes["default"].string
  })),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  returnSingleValue: _propTypes["default"].bool,
  icon: _propTypes["default"].element,
  filter: _propTypes["default"].bool,
  isRemovable: _propTypes["default"].bool,
  onRemove: _propTypes["default"].func,
  disableFlex: _propTypes["default"].bool,
  tethered: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(BasicDropdown, "defaultProps", {
  isRemovable: false,
  tethered: false
});
var Dropdown = (0, _ThemeProvider.withStyles)(_style["default"])(BasicDropdown);
exports.Dropdown = Dropdown;
var DropdownItem = _MenuItem["default"];
exports.DropdownItem = DropdownItem;
//# sourceMappingURL=bootstrap.js.map